import HorizantalBar from "../../../components/horizantalBar/HorizantalBar";
import PageLink from "../../../components/pageLink/PageLink";
import AppVersionNavigator from "../../../navigation/AppVersionNavigator";
import styles from "./appVersionSettings.module.css";

const AppVersionSettings = () => {
  return (
    <div className={styles.container}>
      <HorizantalBar>
        <div className={styles.linksWrapper}>
          <div className={styles.linkWrapper}>
            <PageLink destination="/dashboard/app-settings/app-version">
              التحكم في الاصدار
            </PageLink>
          </div>
        </div>
      </HorizantalBar>
      <AppVersionNavigator />
    </div>
  );
};

export default AppVersionSettings;
